import { Link } from "react-router-dom";
import { featuredComics } from "@/mocks/comics";

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">精选高分韩漫，大家都在看</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-lg mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
                    {comic.rating}
                  </span>
                </div>
                {comic.isHot && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full">
                      HOT
                    </span>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-[10px] text-white/80">{comic.status}</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-sm text-primary-500 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}